import { Injectable } from '@angular/core';

import { IIdentityString } from '../interfaces/util/identity.interface';
import { CrudApiBaseService } from './crud-api.base';

@Injectable({ providedIn: 'root' })
export class ProblemTypeApi extends CrudApiBaseService<IIdentityString> {
  endpoint = 'problemtype';
}
